import {
  configureStore,
  ThunkAction,
  Action,
  combineReducers,
  AnyAction,
} from "@reduxjs/toolkit"
import adminReducer from "./slices/adminSlice"
import appReducer from "./slices/appSlice"
import metricReducer from "./slices/metricSlice"
import opportunityReducer from "./slices/opportunitySlice"
import metricsReducer from "./slices/metricsSlice"
import resourceBudgetReducer from "./slices/resourceBudgetSlice"
import forecastReducer from "./slices/forecastSlice"
import pnlBudgetReducer from "./slices/pnlBudgetSlice"
import userReducer from "./slices/userSlice"
import usersReducer from "./slices/usersSlice"
import rolesAndPermsReducer from "./slices/rolesAndPermsSlice"
import pnlReportingReducer from "./slices/pnlReportingSlice"
import groupProfileReducer from "./slices/groupProfileSlice"
import providersReducer from "./slices/providersSlice"
import dashboardReducer from "./slices/dashboardSlice"
import huddleReducer from "./slices/huddleSlice"
import doctorCompensationReducer from "./slices/doctorCompensationSlice"
import prontoAiReducer from "./slices/prontoAiSlice"
import complianceReducer from "./slices/complianceSlice"
import AgendaReducer from "./slices/agendaSlice"
import HelpCenterReducer from "./slices/helpCenterSlice"
import providerProductionSummaryReducer from "./slices/providerProductionSummarySlice"

const combinedReducer = combineReducers({
  app: appReducer,
  admin: adminReducer,
  metric: metricReducer,
  opportunity: opportunityReducer,
  metrics: metricsReducer,
  groupProfile: groupProfileReducer,
  resourceBudget: resourceBudgetReducer,
  forecast: forecastReducer,
  pnlBudget: pnlBudgetReducer,
  pnlReporting: pnlReportingReducer,
  user: userReducer,
  users: usersReducer,
  rolesAndPerms: rolesAndPermsReducer,
  providers: providersReducer,
  dashboard: dashboardReducer,
  huddle: huddleReducer,
  doctorCompensation: doctorCompensationReducer,
  prontoAi: prontoAiReducer,
  compliance: complianceReducer,
  providerProductionSummary: providerProductionSummaryReducer,
  agenda: AgendaReducer,
  helpCenter: HelpCenterReducer,
})

const rootReducer = (state: any, action: AnyAction) => {
  if (action.type === "RESET") {
    state = {}
  }
  return combinedReducer(state, action)
}

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>

export default store
